import { styled } from '@mui/material/styles'
import { motion } from 'framer-motion'

import { Box, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { IconServerlessFramework } from '_app/icons/IconServerlessFramework'

export const LoadingPage = ({ message }) => {
  return (
    <ContainerPage>
      <Content
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 0.8, opacity: 1 }}
        transition={{ duration: 0.35 }}
      >
        <ServerlessLoader />
        {message && <Typography color="text.secondary">{message}</Typography>}
      </Content>
    </ContainerPage>
  )
}

export default LoadingPage

const useStyles = makeStyles((theme) => ({
  loaderContainer: {
    display: 'flex',
    position: 'relative',
    width: 150,
    height: 165,
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'scale(0.5)',
  },

  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 160,
  },

  outerCircle: {
    backgroundColor: 'transparent',
    border: `4px solid ${theme.palette.grey.light}`,
    opacity: '0.9',
    borderRight: '5px solid transparent',
    borderLeft: '5px solid transparent',
    borderRadius: 100,
    width: 144,
    height: 144,
    margin: '0 auto',
    animation: '$spinPulse 3s infinite ease-in-out',
  },

  innerCircle: {
    backgroundColor: 'transparent',
    border: `3px solid ${theme.palette.primary.main}`,
    opacity: '0.9',
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderRadius: 100,
    top: -133,
    width: 122,
    height: 122,
    margin: '0 auto',
    position: 'relative',
    animation: '$spinOffPulse 1s infinite linear',
  },

  '@keyframes spinPulse': {
    '0%': {
      transform: 'rotate(160deg)',
      opacity: 0,
    },
    '50%': {
      transform: 'rotate(145deg)',
      opacity: 1,
    },
    '100%': {
      transform: 'rotate(-320deg)',
      opacity: 0,
    },
  },

  '@keyframes spinOffPulse': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}))

export const ServerlessLoader = ({
  scale = 1,
  width = 150,
  height = 165,
  showLogo = true,
  ...props
}) => {
  const classes = useStyles()

  return (
    <div
      {...props}
      className={`${classes.loaderContainer} ${props.className || ''}`}
      style={{
        width,
        height,
        transform: `scale(${scale})`,
        userSelect: 'none',
        pointerEvents: 'none',
        ...props.style,
      }}
    >
      {showLogo && (
        <Box
          sx={{
            position: 'relative',
            top: '-10px',
            left: '-5px',
          }}
        >
          <IconServerlessFramework size={70} />
        </Box>
      )}

      <div
        className={classes.loader}
        style={showLogo ? { position: 'absolute' } : { position: 'initial' }}
      >
        <div className={classes.outerCircle}></div>
        <div className={classes.innerCircle}></div>
      </div>
    </div>
  )
}

/**
 * Styles
 */
const ContainerPage = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  height: '100vh',
  width: '100%',
  padding: '0',
  overflow: 'hidden',
  background: theme.palette.secondary.main,
  borderRadius: '6px',
}))

const Content = styled(motion.div)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '-4%',
  padding: '0',
  overflow: 'hidden',
  height: '100%',
  width: '100%',
  boxSizing: 'border-box',
}))
